// extracted by mini-css-extract-plugin
export default {"Background":"resetPasswordSuccess_Background__HYya-","Title":"resetPasswordSuccess_Title__wU17k","Button":"resetPasswordSuccess_Button__E9MO9"};